import React, { useContext, useEffect, useRef, useState } from "react";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import Button from "../../components/shared/Button";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";
import useToken from "../../components/helpers/useToken";
import useUser from "../../components/helpers/useUser";
import { OtpInput } from 'reactjs-otp-input';
import OTPInputField from "../../components/shared/OTPInputField";
import { UserContext } from "../../App";
import axios from "axios";
import OTPTimer from "../../components/shared/OTPTimer";

const LoginPage = () => {

  const {i18n,t} = useTranslation();
  useDocumentTitle('pageTitles.login');
  const navigate = useNavigate();
  const [isFormSubmitDisabled,setIsFormSubmitDisabled] = useState(true);
  const [signInForm,setSignInForm] = useState({username:'', OTP: ''});
  const [errors, setErrors] = useState(null);
  const [showOTP, setShowOTP] = useState(false);
  const [token, setToken] = useToken();
  const [user, setUser] = useUser();
  const {setIsUserLoggedIn} = useContext(UserContext);
  const [currentStep, setCurrentStep] = useState(1);
  const [otpToken, setOTPToken] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [sendNewOTPStatus, setSendNewOTPStatus] = useState(false);

  const timerRef = useRef();

  const convertArabicNumbersToEnglish = string =>
  // eslint-disable-next-line no-bitwise
  string?.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => c.charCodeAt(0) & 0xf);

  useEffect(()=>{
    if(currentStep === 1) {
      if(signInForm && signInForm?.username) {
        setIsFormSubmitDisabled(false);
      } else {
        setIsFormSubmitDisabled(true);
      }
    }
    if(currentStep === 2) {
      if(signInForm && signInForm?.OTP && signInForm?.OTP?.toString().length === 4) {
        setIsFormSubmitDisabled(false);
      } else {
        setIsFormSubmitDisabled(true);
      }
    }
    if(currentStep === 3) {
      if(newPassword && newPassword?.toString().length >=4 && newPasswordConfirm && newPassword === newPasswordConfirm) {
        setIsFormSubmitDisabled(false);
      } else {
        setIsFormSubmitDisabled(true);
      }
    }
    if(currentStep === 4) {
      if(signInForm && signInForm?.username && signInForm?.password) {
        setIsFormSubmitDisabled(false);
      } else {
        setIsFormSubmitDisabled(true);
      }
    }
  },[signInForm,currentStep,newPassword,newPasswordConfirm]);

  const hideError = (err) => {
    if(errors) {
      let errorsList = errors;
      delete errorsList[err];
      setErrors(errorsList);
    }
  }

  const handleClickSignInButton = () => {
    setErrors(null);
    let errorsList = {};
    // if(signInForm?.password?.length !== 4) {
    //   errorsList.password = 'validation.passwordLength';
    // }
    if(currentStep === 1) {
      if(!/^(5)([0-9]{8})$/.test(signInForm?.username?.replace('+966',''))) {
        errorsList.username = 'validation.invalidmobile';
      }
    }
    if(currentStep === 3) {
      if(newPassword?.toString().length > 4) {
        errorsList.password = t('validation.passwordMinLength');
      }
    }
    if(Object.keys(errorsList).length > 0) {
      setErrors(errorsList);
    } else {
      if(currentStep === 1) {
        checkVendorHasPassword();
      }
      if(currentStep === 2) {
        checkOTP();
      }
      if(currentStep === 3) {
        setNewPasswordAction();
      }
      if(currentStep === 4) {
        handleClickSignInButtonAction();
      }
    }
  }


  const checkVendorHasPassword = async () => {
    setIsFormSubmitDisabled(true);
    try {
      const response = await apiClient.get(`/vendors/check-vendor-has-password/${convertArabicNumbersToEnglish(signInForm?.username)?.replace('+966','966')}`);
      // console.log(response?.status);
        if(response?.status === 200 && response?.data) {
          if(response?.data?.hasPassword) {
            setCurrentStep(4);
          } else {
            sendOTP();
          }
        }
      } catch(err) {
        let errorsList = {};
        errorsList.username = err?.response?.data?.message;
        setErrors(errorsList);
        setIsFormSubmitDisabled(false);

    }
  }

  const sendOTP = async () => {
    
    setSendNewOTPStatus(false);

    if (timerRef.current) {
      timerRef.current.resetTimer();
    }
    
    const body = {username: convertArabicNumbersToEnglish(signInForm?.username)?.replace('+966','966')};
    try {
      const response = await apiClient.post(`/vendors/send-otp`,body);
      if(response?.status === 200) {
        setCurrentStep(2);
      } else {
        setErrors({username: t('validation.tryAgainError')});
      }
    } catch(err) {
      setErrors({username: t('validation.tryAgainError')});
    }

  }


  const checkOTP = async () => {
    setIsFormSubmitDisabled(true);
    let body = {username: convertArabicNumbersToEnglish(signInForm?.username)?.replace('+966','966'),otp: convertArabicNumbersToEnglish(signInForm?.OTP)};
    try {
      const response = await apiClient.post(`/vendors/login-otp`,body);
      if(response?.status === 200 && response?.data) {
        setOTPToken(response?.data?.token);
      } else {
        setErrors({OTP: t('validation.invalidOtpCode')});
      }
    } catch(err) {
        setErrors({OTP: t('validation.invalidOtpCode')});
    }
  }

  const setNewPasswordAction = async () => {
    setIsFormSubmitDisabled(true);
    const headers = {
      'Authorization': `Bearer ${otpToken}`
    };
    let base_url;
    if(typeof window !== "undefined" && window.location.host === 'test-vendor-dashboard.fanni.site') {
        base_url = 'https://fanni-testing-1603da5414b1.herokuapp.com';
    } else {
        base_url = process.env.REACT_APP_API_URL;
    }
    try {
      const response = await axios.patch(`${base_url}/vendors/set-password`,{username: convertArabicNumbersToEnglish(signInForm?.username)?.replace('+966','966'),password: convertArabicNumbersToEnglish(newPassword),confirmPassword: convertArabicNumbersToEnglish(newPasswordConfirm)},{headers});
      if(response?.status === 200 || response?.status === 201 || response?.status === 204) {
        setCurrentStep(4);
      } else {
        setErrors({password: t('validation.tryAgainError')});
      }
      setIsFormSubmitDisabled(false);
    } catch(err) {
      setIsFormSubmitDisabled(false);
    }
  }


  const handleClickSignInButtonAction = async () => {
    setIsFormSubmitDisabled(true);
    const body = {...signInForm};
    body.username = convertArabicNumbersToEnglish(body.username)?.replace('+966','966');
    body.password = convertArabicNumbersToEnglish(body.password);
    try {
      const response = await apiClient.post(`/vendors/login`,Object.fromEntries(Object.entries(body).filter(([_, v]) => v !== '')));
      if(response?.status === 200) {
        setToken(response?.data?.token);
        setIsUserLoggedIn(true);
        const getUser = response?.data?.plainUser;
        getUser.username = signInForm?.username.replace('+966','966');
        setUser(getUser);
      } else {
        setIsFormSubmitDisabled(false);
      }
    } catch(err) {
      setIsFormSubmitDisabled(false);
      if(err?.response?.data?.message) {
        let errorsList = {};
        if(err?.response?.data?.category === 'UserNotFound') {
          errorsList.username = err?.response?.data?.message;
        } else if(err?.response?.data?.category === 'accountSuspended') {
          errorsList.username = t('validation.accountSuspended');
        } else {
          errorsList.password = err?.response?.data?.message;
        }
        setErrors(errorsList)
      } else {
        let errorsList = {};
        errorsList.OTP =err?.response?.data?.message;
        setErrors(errorsList);
      }
    }
  }

  useEffect(()=>{
    if(otpToken && currentStep === 2) {
      setCurrentStep(3);
    }
  },[otpToken])

  useEffect(()=>{
    if(token && token !== undefined && token !== 'undefined' && token !== 'remove') {
      navigate(`/${i18n.language}/`);
    }
  },[token])

  useEffect(()=>{
    if(newPassword && newPasswordConfirm && newPassword !== newPasswordConfirm) {
      setErrors({password: t('validation.passwordsNotMatch')});
    }
  },[newPassword,newPasswordConfirm])

  

  const ButtonText = {
    1: t('loginPage.nextBtn'),
    2: t('loginPage.confirmPhoneBtn'),
    3: t('loginPage.createPassBtn'),
    4: t('loginPage.loginBtn'),
  }

  const FormTitle = {
    1: t('loginPage.enterPhoneTitle'),
    2: `${t('loginPage.enterOtpPrefix')}${signInForm?.username ? t('loginPage.phoneEndsWith') + signInForm?.username?.replace(/\\D/g, '')?.slice(-3) : t('loginPage.registeredPhoneText')}.`,
    3: t('loginPage.createPassTitle'),
    4: t('loginPage.enterPassTitle')
  }


  // console.log(isFormSubmitDisabled);
  return (
    <div className="w-full">
      <h3 className="text-grey-900 font-[600] text-[32px] leading-[48px]">{t('loginPage.welcomeDashboard')}</h3>
      <p className="text-grey-600 font-[500] text-[18px] leading-[27px] mt-[15px] pt-[40px]">{FormTitle[currentStep]}</p>
      {/* <p className="text-grey-900 font-[500] text-[18px] leading-[27px]">الرجاء إدخال رقم الجوال أو البريد الإلكتروني المسجل</p> */}
      <div className="w-full max-w-[450px] pt-[20px]">
          {currentStep === 1 ? <div className="mb-[20px]">
            <InputField phone={true} label={t("forms.mobileLabel")} value={signInForm?.username?.replace('+966','')} error={errors?.username} errorMessage={errors?.username} translateError={true} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setSignInForm({ ...signInForm, username: '+966'+e.target.value }) }; hideError('mobile')}} />
          </div> : ''}
          {currentStep === 2 ? <div className="mb-[20px]">
            <OTPInputField label={t('loginPage.verificationCodeLabel')} value={signInForm?.OTP} error={errors?.OTP} errorMessage={errors?.OTP} translateError={true} onChange={(otp)=>{ if(otp === '' || /^[0-9\b]+$/.test(otp)) { setSignInForm({ ...signInForm, OTP: otp }) }; hideError('OTP')}} />
              <span className="text-[18px] font-[500]">
                {t('loginPage.didNotGetCode')}<span className={`${sendNewOTPStatus ? 'text-[#5381B2] cursor-pointer' : 'text-grey-300'}`} onClick={()=>{sendNewOTPStatus ? sendOTP() : ''}}>{t('loginPage.resendText')}</span>{t('loginPage.afterText')}<OTPTimer initialTime={180} onComplete={()=>setSendNewOTPStatus(true)} ref={timerRef} />
              </span>
          </div> : ''}
          {currentStep === 3 ?
            <>
              <div className="mb-[20px]">
                <InputField type="password" label={t('loginPage.passwordLabel')} value={newPassword} placeholder={t('loginPage.enterPassPlaceholder')} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setNewPassword( e.target.value ) }; hideError('password')}} />
              </div>
              <div className="mb-[20px]">
                <InputField type="password" label={t('loginPage.confirmPassLabel')} value={newPasswordConfirm} placeholder={t('loginPage.confirmPassPlaceholder')} error={errors?.password} errorMessage={errors?.password} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setNewPasswordConfirm( e.target.value ) }; hideError('password')}} />
              </div>
            </> : ''
          }
          {currentStep === 4 ? <div className="mb-[20px] relative">
            <div className="absolute top-0 end-0 font-[500] text-[14px] text-orange cursor-pointer z-[5]" onClick={()=>sendOTP()}>{t('loginPage.forgotPassText')}</div>
            <InputField type="password" label={t('loginPage.passwordLabel')} value={signInForm?.password} placeholder={t('loginPage.enterPassPlaceholder')} error={errors?.password} errorMessage={errors?.password} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setSignInForm({ ...signInForm, password: e.target.value }) }; hideError('password')}} />
          </div> : ''}
          <div className="mb-[35px]">
            <Button type="button" text={ButtonText[currentStep]} disabled={isFormSubmitDisabled} onClick={()=>handleClickSignInButton()} />
          </div>
      </div>
    </div>
  );
};

export default LoginPage;
